import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MaterialModule } from "@app/material.module";
import { ClientProjectPickerDialogModule } from "@app/shared/dialogs/client-project-picker-dialog/client-project-picker-dialog.module";
import { TagPickerDialogModule } from "@app/shared/dialogs/tag-picker-dialog/tag-picker-dialog.module";
import { TimeInputModule } from "@app/shared/time-input/time-input.module";
import { UserAvatarModule } from "@app/shared/user-avatar/user-avatar.module";
import { TranslateModule } from "@ngx-translate/core";
import { BulkEditProgressOverlayModule } from "../bulk-edit-progress-overlay/bulk-edit-progress-overlay.module";
import { DurationInputControlModule } from "../duration-input-control/duration-input-control.module";
import { TaskPickerDialogModule } from "../task-picker-dialog/task-picker-dialog.module";
import { TimeRangeControlModule } from "../time-range-control/time-range-control.module";
import { UserSinglePickerDialogModule } from "../user-single-picker-dialog/user-single-picker-dialog.module";
import { TimeBulkEditDialogComponent } from "./time-bulk-edit-dialog.component";

@NgModule({
	declarations: [TimeBulkEditDialogComponent],
	imports: [
		CommonModule,
		MaterialModule,

		FormsModule,
		ReactiveFormsModule,
		TimeInputModule,
		TranslateModule,
		ClientProjectPickerDialogModule,
		TaskPickerDialogModule,
		TagPickerDialogModule,
		TimeRangeControlModule,
		UserSinglePickerDialogModule,
		UserAvatarModule,
		DurationInputControlModule,
		BulkEditProgressOverlayModule,
	],
	exports: [TimeBulkEditDialogComponent],
})
export class TimeBulkEditDialogModule {}
